import React from 'react';
import {RadioGroup, Stack} from "@chakra-ui/react";
import {Field} from "@/components";

export const RadioView = ({ choices, label, required, conditional, onChange,...props }) => {

    return (
        <Field
            label={`${label}${required ? '*' : ''} :`}
            {...props}
        >
            <RadioGroup.Root onChange={onChange}>
                <Stack direction="row">
                    {
                        choices.map((e, i) => <RadioGroup.Item key={`radio-${i}`} value={e}>
                            <RadioGroup.ItemHiddenInput />
                            <RadioGroup.ItemIndicator />
                            <RadioGroup.ItemText>{e}</RadioGroup.ItemText>
                        </RadioGroup.Item>)
                    }
                </Stack>
            </RadioGroup.Root>
        </Field>
    );
};

export default RadioView;
